export const getEnv = (key: string): any => {
	// @ts-ignore
	return window.runtimeEnv && window.runtimeEnv[key] !== undefined ? window.runtimeEnv[key] : import.meta.env[key];
};

export const getRequiredEnv = (key: string): string => {
	const value = getEnv(key);

	if (!value || !value.length) {
		throw Error(`missing env variable '${key}'`);
	}

	return value;
};
